import { get } from './request';
import { stringify } from './query-string';
import { globalDeviceInfo } from './device';
const Location = window.location;
// 本地缓存存取对象
const Storage = {
    get(key) {
        return (window.localStorage && window.localStorage.getItem(key)) || null;
    },
    set(key, value) {
        window.localStorage && window.localStorage.setItem(key, value);
    },
    del(key) {
        window.localStorage && window.localStorage.removeItem(key);
    },
};
// 生成指定长度的id
function getUniqueId(n) {
    if (n < 1)
        return '';
    let result = '';
    while (result.length < n) {
        result += Math.random()
            .toString(36)
            .substr(2);
    }
    return result.substr(0, n);
}
const Stat = {
    EVENTS: {},
    START_TIME: new Date(),
    SERVER: 'https://tongji.szzbmy.com/tj.gif',
    ORIGIN: `${Location.protocol}//${Location.host}`,
    PATHNAME: Location.pathname,
    HREF: Location.href,
    MAX_COUNT: 1,
    queue: [],
    CLASS_INTO: 'INTO',
    CLASS_DURATION: 'DURATION',
    CLASS_RELOAD: 'RELOAD',
    CLASS_CMP: 'COMPONENT',
    CLASS_LINK_INTO: 'LINK_TO',
    // CLASS_IMAGE: "IMAGE"
    CLASS_REQUEST: 'REQUEST',
    ACTION_INIT: 'INIT',
    ACTION_CLICK: 'CLICK',
    ACTION_UPD: 'UPDATE',
    inited: false,
    authid: '',
    on(name, fn) {
        if (typeof name !== 'string') {
            for (const key of Object.keys(name)) {
                this.on(key, name[key]);
            }
            return;
        }
        if (!fn)
            return;
        const events = this.EVENTS;
        const list = events[name] || [];
        list.push(fn);
        events[name] = list;
    },
    trigger(name, args = []) {
        const events = this.EVENTS;
        const list = events[name] || [];
        for (const item of list) {
            item.apply(this, args);
        }
    },
    init(opts = {}) {
        this.inited = true;
        this.authid = opts.authid || '';
        this.sendInto();
        this.post();
        window.setTimeout(() => {
            const _old = window.onbeforeunload;
            window.onbeforeunload = (evt) => {
                let returnVal;
                if (_old) {
                    returnVal = _old.call(window, evt);
                }
                if (!returnVal) {
                    this.trigger('onLeave', []);
                    this.sendReload();
                    this.post();
                }
                return returnVal;
            };
        }, 0);
    },
    getUser() {
        return;
    },
    checkQueue() {
        const queue = this.queue;
        const len = queue.length;
        if (len < this.MAX_COUNT) {
            return;
        }
        this.post();
    },
    post() {
        const queue = this.queue;
        this.queue = [];
        for (const item of queue) {
            const ajax = item.ajax;
            delete item.ajax;
            const queryStr = stringify(item);
            const path = `${this.SERVER}?${queryStr}`;
            this.request(path, ajax);
        }
    },
    request(path, ajax) {
        if (ajax !== true) {
            const img = new Image();
            img.onload = () => {
                // $(img).remove();
                img.onload = null;
            };
            img.src = path;
            return;
        }
        get(path)
            .then(() => undefined)
            .catch(() => undefined);
        // $.ajax({
        //   url: path,
        //   async: false,
        //   timeout: 400
        // });
    },
    send(cls, name, action, others = {}) {
        if (this.inited !== true)
            return;
        if (!cls)
            return;
        const now = new Date();
        const host = this.ORIGIN;
        const href = this.HREF;
        const url = href.replace(host, '');
        // const user = others.user;
        delete others.user;
        const data = {
            // authid: this.authid,
            host,
            url,
            time: now.toISOString(),
            timestamp: +now,
            class: cls,
            name,
            action,
            // user: user || this.getUser(),
            cookies_id: this.getCookiesId(),
            browser_name: globalDeviceInfo.browser.name,
        };
        for (const key of Object.keys(others)) {
            data[key] = others[key];
        }
        this.queue.push(data);
        this.checkQueue();
    },
    getOthersAgent() {
        return '';
    },
    getCookiesId() {
        const key = 'RP_COOKIES_ID';
        let cookiesId = Storage.get(key);
        if (!cookiesId) {
            cookiesId = getUniqueId(16);
            Storage.set(key, cookiesId);
        }
        return cookiesId;
    },
    getUserAgent() {
        let userAgent = window.navigator.userAgent;
        const others = this.getOthersAgent();
        userAgent += ` ${others}`;
        return userAgent;
    },
    sendInto() {
        const root = document.documentElement;
        this.send(this.CLASS_INTO, this.getUserAgent(), null, {
            width: window.innerWidth || (root ? root.clientWidth : 0),
            height: window.innerHeight || (root ? root.clientHeight : 0),
            screen_width: window.screen.availWidth,
            screen_height: window.screen.availHeight,
        });
    },
    sendReload() {
        const start = this.START_TIME;
        const end = new Date();
        this.send(this.CLASS_RELOAD, '' + (end.getTime() - start.getTime()), null);
    },
    sendRequest(name, action, params = {}, time, result, msg) {
        if (!name)
            return;
        const others = {
            params: JSON.stringify(params),
            duration: time,
            result,
            msg,
        };
        this.send(this.CLASS_REQUEST, name, action, others);
    },
    sendLinkTo(name, link_desc, link_from, link_target, others = {}) {
        if (!name)
            return;
        const action = this.ACTION_INIT;
        if (!link_from) {
            link_from = this.PATHNAME;
        }
        if (!link_target) {
            link_target = '_self';
        }
        if (link_target === '_self') {
            others.ajax = true;
        }
        const opts = {
            desc: link_desc,
            from: link_from,
            target: link_target,
        };
        for (const key of Object.keys(others)) {
            opts[key] = others[key];
        }
        others = opts;
        this.send(this.CLASS_LINK_INTO, name, action, others);
    },
    /**
     * 上报统计数据
     * @param {string} name        上报名称
     * @param {string} cmpclass    上报组件类
     * @param {string} cmpvalue    上报组件值
     * @param {string} [action]      上报类型
     * @param { Record<string, any>} [others={}] 上报附加数据
     */
    sendComponent(name, cmpclass, cmpvalue, action, others = {}) {
        if (!name)
            return;
        if (!action)
            action = this.ACTION_INIT;
        const opts = { cmpclass, cmpvalue };
        for (const key of Object.keys(others)) {
            opts[key] = others[key];
        }
        others = opts;
        this.send(this.CLASS_CMP, name, action, others);
    },
    /**
     * 新的上报方法，去除多余的字段
     * @param {*} others 上报字段
     */
    sendStat(others = {}) {
        if (this.inited !== true) {
            return;
        }
        if (!others.id) {
            return console.warn('stat数据上报缺少id字段', others);
        }
        const now = new Date();
        const host = this.ORIGIN;
        const href = this.HREF;
        const url = href.replace(host, '');
        const data = {
            host,
            url,
            time: now.toISOString(),
            timestamp: +now,
            cookies_id: this.getCookiesId(),
            browser_name: globalDeviceInfo.browser.name,
            ...others,
        };
        this.queue.push(data);
        this.checkQueue();
    },
};
export default Stat;
//# sourceMappingURL=stat.js.map